import { useEffect, useState } from "react";
import DynamicPdfCard from "../../include/DynamicPdfCard";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";

const Moa = () => {
  const [banner, setBanner] = useState({
    title: "",
    desktopImages: [],
    mobileImages: [],
  });

  const [cardData, setCardData] = useState({ heading: "", documents: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/api/dynamicpages/moa");
        const data = res.data || {};


        const bannerData = data.banner_data || {};
        setBanner({
          title: bannerData.title || "",
          desktopImages: Array.isArray(bannerData.desktop_images)
            ? bannerData.desktop_images
            : [],
          mobileImages: Array.isArray(bannerData.mobile_images)
            ? bannerData.mobile_images
            : [],
        });


        /* ---------- Page Content ---------- */
        const contents =
          data?.tab_content?.main_dynamic_page_content || [];

        const headingBlock = contents.find(
          (item) => item.type === "heading_block"
        );

        const documents = contents
          .filter((item) => item.type === "document_upload_link")
          .map((item) => ({
            title: item.heading,
            pdfLink: item.image_url, // ✅ IMPORTANT FIX
            type: item.image_url?.endsWith(".doc") || item.image_url?.endsWith(".docx")
              ? "word"
              : "pdf",
          }));

        setCardData({
          heading: headingBlock?.heading || "",
          documents,
        });
      } catch (err) {
        console.error("Error loading MoA:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return <div className="container py-5 text-center">Loading...</div>;

  return (
    <section className="e-sanad-page">
      <DynamicBanner title={banner.title} bgImage={banner.desktopImages} bgImageMobile={banner.mobileImages}
      />


      <DynamicPdfCard
        heading={cardData.heading}
        documents={cardData.documents}
      />
    </section>
  );
};

export default Moa;
